<script>
    import Button from "@smui/button/Button.svelte";

    import Textfield from "@smui/textfield";
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import title from "../../components/title";
    import { getObject, setObject } from "../../session";

    export let location;

    export let name = "";
    export let phone = "";

    function next() {
        const order = getObject("order");
        order["recipient_name"] = name;
        order["recipient_phone"] = phone;
        setObject("order", order);
        console.log(order);
        navigate("/destination/address");
    }

    onMount(() => {
        const order = getObject("order");
        title.set("Alamat Tujuan");
        if ("recipient_name" in order) name = order["recipient_name"];
        if ("recipient_phone" in order) phone = order["recipient_phone"];
    });
</script>

<style lang="scss">
    .button-container {
        opacity: 1;
        transition: 300ms all ease-out;
        text-align: right;
        &.hide {
            visibility: hidden;
            opacity: 0;
            transition: 300ms all ease-out;
        }
    }
</style>

<div class="content">
    <div class="caption">Siapa kontak yang akan menerima paket?</div>
    <Textfield
        bind:value={name}
        variant="outlined"
        label="Nama penerima"
        input$placeholder="Siapa namanya?" />
    <Textfield
        bind:value={phone}
        variant="outlined"
        label="Nomor telepon"
        input$placeholder="Berapa nomor teleponnya?" />
    <div
        class="button-container column"
        class:hide={name.length < 4 || phone.length < 10}>
        <Button on:click={next} variant="unelevated" class="rounded">
            Lanjutkan
        </Button>
    </div>
</div>
